import '/public/static/css/module/depth2Menu.scss';
import {SoopUiSwiper} from '@/components/ui';
import useGlobalUIStore from '@/stores';
import useDirectoryStore from '@/stores/directory';
import {sendWebUvLog} from '@/utils/main';
import {sendClickLog} from '@/utils/main/my-plus/log';
import {useEffect, useRef} from 'react';
import {useNavigate} from 'react-router-dom';

/**
 * 탐색 영역 상단, 서비스 관리자에 의해 설정되는 카테고리 목록 UI 영역 a.k.a 어드민 칩(운영 칩)
 * @param {Object} params
 * @param {boolean} params.isCategory 현재 표시되는 영역이 카테고리 상세 페이지인지 여부
 * @returns
 */
export const AdminCategoryMenu = ({isCategory = false}) => {
  const swiperConfig = {
    slidesPerView: 'auto',
    loop: false,
    spaceBetween: 6,
  };
  const {
    selectedCategoryTab,
    selectedCategoryInfo,
    setSelectedCategoryTab,
    setSelectedCategoryInfo,
    clearSelectedCategoryInfo,
    categoryMenu,
  } = useDirectoryStore();
  const {setRefreshTimestamp} = useGlobalUIStore();
  const navigate = useNavigate();

  /** 카테고리 메뉴 리스트 호출 후 데이터 반영 */
  useEffect(() => {
    if (categoryMenu.length > 0) {
      if (!selectedCategoryInfo.menuId) {
        setSelectedCategoryTab(selectedCategoryTab);
      } else {
        for (let item of categoryMenu) {
          // 선택된 카테고리 발견 시
          if (item.menuId === Number(selectedCategoryInfo.menuId)) {
            setSelectedCategoryInfo({
              type: item.type,
              adminId: item.adminId,
              menuName: item.menuName,
              menuId: item.menuId,
              contentsDisplay: {
                live: item.contentsDisplay?.live,
                vod: item.contentsDisplay?.vod,
                catch: item.contentsDisplay?.catch,
              },
            });
            setSelectedCategoryTab(
              item.contentsDisplay?.live
                ? 'live'
                : item.contentsDisplay?.vod
                  ? 'vod'
                  : item.contentsDisplay?.catch
                    ? 'catch'
                    : 'live',
            );
            break;
          }
        }
      }
    }
  }, [
    categoryMenu,
    selectedCategoryInfo.menuId,
    setSelectedCategoryInfo,
    setSelectedCategoryTab,
  ]);

  const refreshTimer = useRef(false);
  const handleOnClickCategoryMenu = (e, item) => {
    e.preventDefault();
    const {type, menuId, menuName, adminId, contentsDisplay} = item;

    if (selectedCategoryInfo.menuId === menuId) {
      // 반복 클릭 방지 로직
      if (refreshTimer.current) {
        return;
      }
      setRefreshTimestamp();
      sendWebUvLog(null);
      refreshTimer.current = true;
      setTimeout(() => {
        refreshTimer.current = false;
      }, 1500);
    }

    if (type !== 'category') {
      setSelectedCategoryInfo({
        type: type,
        adminId: adminId,
        menuName: menuName,
        menuId: menuId,
        contentsDisplay: {
          live: contentsDisplay?.live,
          vod: contentsDisplay?.vod,
          catch: contentsDisplay?.catch,
        },
      });
      sendClickLog('cate_admin', {
        buttonType: 'directory_admin',
        location: 'directory',
        filterIdx: menuId,
      });
      navigate(`/directory/category/${menuId}/live`, {
        replace: selectedCategoryInfo.menuId === menuId, // 동일 어드민 칩 다시 클릭 시 History 업데이트 X
      });
    } else {
      clearSelectedCategoryInfo();
      navigate(`/directory/category`, {
        replace: selectedCategoryInfo.menuId === menuId && !isCategory,
      });
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {categoryMenu && (
        <div className='dept2_menu_wrap'>
          <SoopUiSwiper
            options={swiperConfig}
            includesControlsIntoSwiper={true}
            swiperClass='tab_swiper_item'
            swiperTag='ul'>
            {categoryMenu.map((item, idx) => (
              <li
                className={`swiper-slide ${
                  selectedCategoryInfo.menuId === item?.menuId ? 'on' : ''
                }`}
                key={idx}>
                <a
                  role='button'
                  onClick={(e) => handleOnClickCategoryMenu(e, item)}>
                  {item.menuName}
                </a>
              </li>
            ))}
          </SoopUiSwiper>
        </div>
      )}
    </>
  );
};
